export type HeroProof = {
  name: string;
  location: string;
  photo: string;
  quote: string;
};

export const heroProof: HeroProof[] = [
  {
    name: 'Emily Hartley',
    location: 'Bristol, United Kingdom',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/e7ed5380-1aa0-4eb0-b8b6-8040184b0408.jpg',
    quote:
      '"A client mentioned a herniated disc two minutes before class. Three questions later I knew exactly what to teach her."',
  },
  {
    name: 'Danielle Okoye',
    location: 'Toronto, Canada',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/4ccb537c-e5c7-44ca-a68b-a0d2f348685e.jpg',
    quote:
      '"I stopped watering down whole classes. Now I adapt for one body and everyone else keeps working hard."',
  },
  {
    name: 'Megan Fowler',
    location: 'Austin, Texas',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/d6e35c6e-b4e4-4e90-830d-18023c1b2211.jpg',
    quote:
      '"The refer-out scripts are the part I use most. I sound like a professional instead of guessing out loud."',
  },
];
